import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Container, Form, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Badge, Button, Dropdown } from "react-bootstrap";
import { DateRangePicker } from "react-date-range";
import moment from "moment";
import moments from "moment-timezone"
import { toast } from "react-toastify";
import WhatsAppAPI from "../../../api/schoolApi";
import Confirm from "../../Confirm";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const Templateview = ({ selectedWhatsAppSetting }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [templateData, setTemplateData] = useState(location.state ? location.state : {});



// Unix timestamp ko readable date format me convert karne ke liye:

  const [body, setBody] = useState([]);
  const [isSpinner, setIsSpinner] = useState(false);
   const [templateDelete, setTemplateDelete] = useState(false);
       const [rowData, setRowData] = useState();
       const [formattedData,setFormattedData] =useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileURL, setSelectedFileURL] = useState(null);
  const [selectedFileType, setSelectedFileType] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const docxIcon = "/user_images/doc-icon.png";
  const fileInputRef = useRef(null);

  const [dateRange, setDateRange] = useState([]);
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef(null);
  console.log("templateData->", templateData);
  useEffect(() => {
    //setParameters({});

    if (templateData && typeof tamplateparms === "object") {
      const { sendToAdmin, file, file_id, whatsapp_number_admin, ...restParameters } = templateData;
      if (file) {
        setSelectedFile(file);
        setSelectedFileType(file.type);
        setSelectedFileURL(URL.createObjectURL(file));
      }

    }

  }, [templateData]);
  const renderFormattedMessage = () => {
    let formattedText = templateData?.message_body || "";
    //Object.keys(parameters).forEach((key) => {
    //  const placeholder = `{{${key}}}`;
    //  const replacement = parameters[key] || placeholder;
    //  formattedText = formattedText.replace(new RegExp(placeholder, "g"), replacement);
    //});
    formattedText = formattedText.replace(/(\n)+/g, "<br />");
    formattedText = formattedText.replace(/\*(.*?)\*/g, "<strong>$1</strong>");
    return <span dangerouslySetInnerHTML={{ __html: formattedText }} />;
  };
  const getHeader = () => {
    if (selectedFileURL) {
      if (selectedFileType && selectedFileType.includes("image")) {
        return <img src={selectedFileURL} alt="Uploaded Preview" className="img-fluid rounded w-100 mb-2" style={{ height: "200px", objectFit: "cover" }} />;
      } else if (selectedFileType && selectedFileType.includes("video")) {
        return <video src={selectedFileURL} controls className="img-fluid rounded w-100 mb-2" style={{ height: "200px", objectFit: "cover" }} />;
      } else if (selectedFileType) {
        return <a href={selectedFileURL} target="_blank" rel="noopener noreferrer">
          <img src={docxIcon} alt="Document Thumbnail" className="img-fluid rounded w-100 mb-2" style={{ height: "200px", objectFit: "cover" }} />
        </a>;
      }
    }

    if (templateData?.header) {
      //console.log("hear pankaj");

      switch (templateData.header) {
        case "IMAGE":
          return <img src={templateData.header_image_url} alt="Template Header" className="img-fluid rounded w-100 mb-2" style={{ height: "200px", objectFit: "cover" }} />;
        case "VIDEO":
          return <video src={templateData.header_video_url} controls className="img-fluid rounded w-100 mb-2" style={{ height: "200px", objectFit: "cover" }} />;
        case "DOCUMENT":
          return <a href={templateData.header_document_url} target="_blank" rel="noopener noreferrer">
            <img src={docxIcon} alt="Document Thumbnail" className="img-fluid rounded w-100 mb-2" style={{ height: "200px", objectFit: "cover" }} />
          </a>;
        default:
          return <strong>{templateData.header_text}</strong>;
      }
    }

    return null;
  };

  const getFooter = () => (templateData.footer ? <div className="template-footer text-muted">{templateData.footer}</div> : null);

  const getButtons = () => {
    if (templateData.buttons && templateData.buttons.length > 0) {
      const quickReplyButtons = templateData.buttons.filter((button) => button.type === "QUICK_REPLY");
      const otherButtons = templateData.buttons.filter((button) => button.type !== "QUICK_REPLY");

      return (
        <div className="template-buttons mt-3">
          {otherButtons.map((button, index) => (
            <div key={index} className="btn btn-outline-secondary btn-sm mb-2">
              {button.text}
            </div>
          ))}
          {quickReplyButtons.length > 1 && (
            <div className="btn btn-outline-secondary btn-sm mb-2">See More Options</div>
          )}
        </div>
      );
    }
    return null;
  };
  const handleBack = () => {
    navigate("/Templates");
  }
  const closeCalendar = () => {
    setShowCalendar(false);
  }
  const removeSelectedRow = (data) => {
    setTemplateDelete(true);

    setRowData(data?.templateData);
}
const deleteTemplate = async () => {
    if (rowData.id && rowData.name) {
        const result = await WhatsAppAPI.deleteTemplateRecord(rowData.id, rowData.name,selectedWhatsAppSetting);
        if (result.success) {
            setTemplateDelete(false);
            //toast.success('Template deleted successfully.');
            navigate("/Templates");
            //setTimeout(() => {
            //}, 2000);
            //fetchAllTemplates(selectedWhatsAppSetting);
        } else {
            setTemplateDelete(false);
            //toast.error(result.error.message);
        }
    }
}

  const handleSelect = (ranges) => {
    console.log("ranges->",ranges);
    
    setDateRange([ranges.selection]);
  };

  const selectDate = () => {
    setShowCalendar(false);
    let firstdate = moments(dateRange[0]?.startDate).tz("Asia/Kolkata").startOf('day').unix();
    let lastdate = moments(dateRange[0]?.endDate).tz("Asia/Kolkata").endOf('day').unix();
    init(firstdate, lastdate);
  }
//  useEffect(() => {
//    setDateRange([
//      {
//        startDate: moment().startOf('month').format(),
//        endDate: moment().endOf('month').format(),
//        key: 'selection'
//      }
//    ]);
//
//    let firstdate = moment().tz("Asia/Kolkata").startOf('month').unix();
//    let lastdate = moment().tz("Asia/Kolkata").endOf('month').unix();
//
//
//
//    init(firstdate, lastdate);
//    setIsSpinner(false);
//
//  }, [selectedWhatsAppSetting]);
//useEffect(() => {
//  const currentTime = moment().tz("Asia/Kolkata").unix(); // Current timestamp
//  const ninetyDaysAgo = currentTime - (90 * 24 * 60 * 60); // 90 days ago
//
//  let firstdate = Math.max(moment().tz("Asia/Kolkata").startOf('month').unix(), ninetyDaysAgo);
//  let lastdate = Math.min(moment().tz("Asia/Kolkata").endOf('month').unix(), currentTime);
//  //let firstdate = moments(dateRange[0]?.startDate).tz("Asia/Kolkata").startOf('day').unix();
//  //let lastdate = moments(dateRange[0]?.endDate).tz("Asia/Kolkata").endOf('day').unix();
//  setDateRange([
//      {
//          startDate: new Date(firstdate),
//          endDate: new Date(lastdate),
//          key: 'selection'
//      }
//  ]);
//  
//  init(firstdate, lastdate);
//  setIsSpinner(false);
//}, []);
useEffect(() => {
  const currentTime = moment().tz("Asia/Kolkata").unix(); // Current timestamp in seconds
  const ninetyDaysAgo = currentTime - 90 * 24 * 60 * 60; // 90 days ago in seconds

  let firstdate = Math.max(moment().tz("Asia/Kolkata").startOf('month').unix(), ninetyDaysAgo);
  let lastdate = Math.min(moment().tz("Asia/Kolkata").endOf('month').unix(), currentTime);
console.log("firstdate->",firstdate);//TemplateView.jsx:201 firstdate-> 1743445800
if (!firstdate || isNaN(firstdate)) {
setDateRange([
  {
    startDate: moment.unix(firstdate).toDate(),  // Ensures correct conversion
    endDate: moment.unix(lastdate).toDate(),
    key: 'selection'
  }
]);
}
  //setDateRange([
  //  {
  //    startDate: new Date(firstdate * 1000), // Convert seconds to milliseconds
  //    endDate: new Date(lastdate * 1000),   // Convert seconds to milliseconds
  //    key: 'selection'
  //  }
  //]);

  init(firstdate, lastdate);
  setIsSpinner(false);
}, []);

  async function init(start = '', end = '') {
    setIsSpinner(false);
    // if (!selectedWhatsAppSetting) return; // Prevent API call if the value is empty


    const billData = await WhatsAppAPI.getTemplateaAmountBySetting(templateData?.id, start, end);
    //const billData = { success: false };

    if (billData.success) {
      
      let totalAmountSpent = 0;
let totalCostPerDelivered = 0;
let totalSent = 0;
let totalDelivered = 0;
let totalRead = 0;
const formattedData = billData.result.map(item => ({
  date: new Date(item.start * 1000).toLocaleDateString(),
  sent: item.sent || 0,
  delivered: item.delivered || 0,
  read: item.read || 0
}));
setFormattedData(formattedData)
billData.result.forEach(record => {
    totalSent += record.sent || 0;
    totalDelivered += record.delivered || 0;
    totalRead += record.read || 0;

    record.cost.forEach(cost => {
        if (cost.type === 'amount_spent' && cost.value) {
            totalAmountSpent += cost.value;
        }
        //if (cost.type === 'cost_per_delivered' && cost.value) {
        //    totalCostPerDelivered += cost.value;//only one time
        //}
    });
    const costPerDelivered = record.cost.find(cost => cost.type === 'cost_per_delivered' && cost.value);
if (costPerDelivered) {
    totalCostPerDelivered = costPerDelivered.value;
}
});
setBody({totalSent,totalDelivered,totalRead,totalAmountSpent:totalAmountSpent.toFixed(2),totalCostPerDelivered: totalCostPerDelivered.toFixed(2)});
console.log("Total Sent Messages:", totalSent);
console.log("Total Delivered Messages:", totalDelivered);
console.log("Total Read Messages:", totalRead);
console.log("Total Amount Spent:", totalAmountSpent.toFixed(2));
console.log("Total Cost Per Delivered:", totalCostPerDelivered.toFixed(2));
      //let body = fetchTableData(billData.result);
      //setBillBody(body);
    setIsSpinner(true);

    } else {
      setBody([]);
      //setBillBody(null);
      //toast.error(billData.error);
    }
    //setIsSpinner(true);
  }

  const editTemplate = (data) => {
    navigate(`/whatsapp_template/add`, { state: data?.templateData });
}

  return (
    <>
      <Container className="mt-5">
        <Row className="mx-5 section-header border-bottom pb-3">
          <Col lg={12}>
            <Row className="align-items-center">
              <Col lg={6} sm={12} xs={12} className="mb-2 mb-lg-0">
                <div className="fw-bold">Template</div>
                <h5 className="mt-1">
                  {templateData?.templatename}{' '}
                  <span>• {templateData?.language}</span>
                </h5>
                <span>{templateData?.category}</span>
              </Col>

              <Col lg={6} sm={12} xs={12} className="text-lg-end text-start">
              <Row>
              <Col lg={6} sm={12} xs={12}  className="text-end ">
                  
                  <div className="position-relative">
                    <Form.Group className="d-flex align-items-center">
                      <Form.Control
                        type="text"
                        readOnly
                        className="border p-2 cursor-pointer form-control"
                        value={`${moment(dateRange[0]?.startDate).format("DD/MM/YYYY")} - ${moment(dateRange[0]?.endDate).format("DD/MM/YYYY")}`}
                        onClick={() => setShowCalendar(!showCalendar)}
                      />
                    </Form.Group>

                    {showCalendar && (
                      <div ref={calendarRef} className="calendar-wrapper">
                        <Card bg="light" className="shadow">
                          <Card.Body>
                            <DateRangePicker
                              showSelectionPreview={true}
                              ranges={dateRange}
                              onChange={handleSelect}
                              direction="horizontal"
                              months={2}
                              moveRangeOnFirstSelection={false}
                              maxDate={new Date()} 
                              minDate={new Date(new Date().setDate(new Date().getDate() -88))}
                            />
                          </Card.Body>
                          <Card.Footer className="text-end">
                            <Button className="me-2" onClick={closeCalendar}>
                              Close
                            </Button>
                            <Button onClick={selectDate}>Select Date</Button>
                          </Card.Footer>
                        </Card>
                      </div>
                    )}
                  </div>

                </Col>
                <Col lg={6} sm={12} xs={12}  className="text-start"> 
                <Button className="mx-2 btn-sm" variant="outline-light" onClick={handleBack}>
                  Back
                </Button>
                <Button className="mx-2 btn-sm" variant="light"  onClick={() => editTemplate({ templateData })}>
                  Edit
                </Button>
                <Button className="btn-sm mx-2" variant="danger" onClick={() => removeSelectedRow({ templateData })}>
                  Delete
                </Button>
     
                </Col>
              </Row>
                <Row>
                  
                </Row>

              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {isSpinner ?

      <Container className="mt-5">
        <Row className="mx-5 pb-3">

          <div className="col-md-4">
            <Card className="shadow">
              <Card.Body>
                <Card.Title className="fw-bold mb-3">Your template</Card.Title>
                                <div className="whatsapp-background w-100">
                  <div className="template-box">
                    {getHeader()}
                    <div className="template-content mt-3">
                      {renderFormattedMessage()}
                      {getFooter()}
                      {getButtons()}
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-8">
            <div className="row g-4">
              <div className="col-md-6">
                <Card className="text-center shadow-sm">
                  <Card.Body>
                    <Card.Title className="fw-bold">Amount spent</Card.Title>
                    <p className="display-6 fw-semibold mt-2">₹{body.totalAmountSpent}</p>
                  </Card.Body>
                </Card>
              </div>

              <div className="col-md-6">
                <Card className="text-center shadow-sm">
                  <Card.Body>
                    <Card.Title className="fw-bold">Cost per message delivered</Card.Title>
                    <p className="display-6 fw-semibold mt-2">₹{body.totalCostPerDelivered}</p>
                  </Card.Body>
                </Card>
              </div>
            </div>

            <Card className="mt-4 shadow-sm">
              <Card.Body>
                <Card.Title className="fw-bold mb-3">Performance</Card.Title>
                <div className="row text-center">
                  <div className="col-md-4">
                    <h6 className="text-muted">Messages sent</h6>
                    <p className="h4 fw-semibold">{body?.totalSent}</p>
                  </div>
                  <div className="col-md-4">
                    <h6 className="text-muted">Messages delivered</h6>
                    <p className="h4 fw-semibold">{body?.totalDelivered}</p>
                  </div>
                  <div className="col-md-4">
                    <h6 className="text-muted">Messages read</h6>
                    <p className="h4 fw-semibold">{body?.totalRead}</p>
                  </div>
                  {/*<div className="col-md-3">
                    <h6 className="text-muted">Replies</h6>
                    <p className="h4 fw-semibold">0</p>
                  </div>*/}
                </div>

                <div className="mt-4 bg-light d-flex align-items-center justify-content-center rounded" style={{ height: '200px' }}>
                  {/*<p className="text-muted">Graph Placeholder</p>*/}
                  <ResponsiveContainer width="100%" >
      <LineChart data={formattedData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="sent" stroke="#ff4d4f" name="Messages Sent" />
        <Line type="monotone" dataKey="delivered" stroke="#722ed1" name="Messages Delivered" />
        <Line type="monotone" dataKey="read" stroke="#52c41a" name="Messages Read" />
      </LineChart>
    </ResponsiveContainer>
                </div>
              </Card.Body>
            </Card>
          </div>
        </Row>
      </Container>
        :

        <div className="sk-cube-grid">
            <div className="sk-cube sk-cube1"></div>
            <div className="sk-cube sk-cube2"></div>
            <div className="sk-cube sk-cube3"></div>
            <div className="sk-cube sk-cube4"></div>
            <div className="sk-cube sk-cube5"></div>
            <div className="sk-cube sk-cube6"></div>
            <div className="sk-cube sk-cube7"></div>
            <div className="sk-cube sk-cube8"></div>
            <div className="sk-cube sk-cube9"></div>
        </div>}
      {templateDelete && (
                <Confirm
                    show={templateDelete}
                    onHide={() => setTemplateDelete(false)}
                    deleteTemplate={deleteTemplate}
                    title="Confirm Delete"
                    message="You are going to delete the record. Are you sure?"
                    table="template"
                />
            )}
    </>
  );

};

export default Templateview;


